// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"catalog_ko-KR__cMeYH","impressionTrackingContainer":"catalog_impressionTrackingContainer__gVchS","alertLanding":"catalog_alertLanding__wEIiX","spin":"catalog_spin__bNYxi"};